import { EGender } from '@enums/Gender';
import errorsValidation from '@errors/validation';
import z from 'zod';

export const formSchema = z.object({
  weight: z.string().min(1, {
    message: errorsValidation.required,
  }),
  age: z.string().min(1, {
    message: errorsValidation.required,
  }),
  gender: z.enum(EGender, {
    message: errorsValidation.required,
  }),
  serumSodium: z.string().min(1, {
    message: errorsValidation.required,
  }),
  bloodGlucose: z.string().min(1, {
    message: errorsValidation.required,
  }),
  solution1: z.string().min(1, {
    message: errorsValidation.required,
  }),
  solution2: z.string().min(1, {
    message: errorsValidation.required,
  }),
  mEq24h: z.string().min(1, {
    message: errorsValidation.required,
  }),
});
